import _ from 'lodash';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import Debug from '~/utils/debug';
import { GOAL_LEAD_GENERATION } from '~/utils/constants';
import { mapState, mapGetters } from 'vuex';
import defaultImageData from './assets/default.jpg';

const debug = Debug('LeadFormPreview'); // eslint-disable-line

export default {
  props: {
    headerImage: String,  // image URL
    facebookPage: {
      default: () => ({}),
      type: Object,
    },
    question: String,
    inputFields: Array,
  },
  components: {
    swiper,
    'swiper-slide': swiperSlide,
  },
  data() {
    return {
      fbPageDefaults: {
        link: '#',
        name: 'Jasper\'s Market',
        picture: defaultImageData,
      },
      swiperOptions: {
        autoplay: 5000,
        autoplayDisableOnInteraction: false,
        autoplayPaused: false,
        onTransitionStart(swiperEl) {
          const classes = swiperEl.container[0].className.split(' ');
          if (classes.indexOf('swiper-sliding') === -1) {
            swiperEl.container[0].className += ' swiper-sliding';
          }
        },
        onTransitionEnd(swiperEl) {
          const classes = swiperEl.container[0].className.split(' ');
          const elIndex = classes.indexOf('swiper-sliding');
          if (elIndex !== -1) {
            classes.splice(elIndex, 1);
          }
          swiperEl.container[0].className = classes.join(' ');
        },
      },
      defaultImageData,
    };
  },
  computed: {
    ...mapState('genericConfig', ['config']),
    ...mapGetters('campaign', ['currentCampaign']),
    fbPage() {
      const settings = this.fbPageDefaults;

      Object.keys(settings).forEach((index) => {
        if (this.facebookPage && Object.hasOwnProperty.call(this.facebookPage, index)) {
          settings[index] = this.facebookPage[index];
        }
      });

      return settings;
    },
    selectOptions() {
      return [
        { text: 'Select' },
        ...this.inputFields.map(elem => ({
          value: elem,
          text: this.underscoreToSpace(elem) })),
      ];
    },
    isLeadQuestionVisible() {
      return !_.get(this.config, `goal_types.${GOAL_LEAD_GENERATION}.config.default_question_disabled`, true);
    },
  },
  filters: {
    underscoreToSpace(value) {
      return value.replace(/_/g, ' ');
    },
  },
  methods: {
    getPrivacyUrl() {
      if (this.currentCampaign.details) {
        const privacyLink = this.currentCampaign.details.filter(arr => arr.name === 'leadPrivacyLink')[0];
        return _.get(privacyLink, 'value', '');
      }
      return '';
    },
    underscoreToSpace(value) {
      if (!value) return '';
      return value.replace(/_/g, ' ');
    },
    triggerUpdate() {
      this.$nextTick(() => {
        this.$refs.swiper.swiper.autoplayPaused = false;
        this.$refs.swiper.swiper.update();
        this.$refs.swiper.swiper.init();
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/lead-form-preview/LeadFormPreview.js